<template>
    <div class="create row flex">
        <div class="profileImg">
            <div class="col-xs-12" style="padding: 0">
                <kr-file-picture :form="form" name="avatar" :options="{ width: '200', height: '200' }"></kr-file-picture>
            </div>
        </div>
        <div class="col-xs-12 col-md-8 col-lg-6">
            <div class="col-xs-12 flex">
                <div class="col-xs-12 col-md-6">
                    <kr-field
                        :display="$t('modules.teachers.create.firstnameLabel')"
                        :form="form"
                        name="firstname"
                        :options="{ placeholder: 'e.g. John', required: true }"
                    ></kr-field>
                </div>

                <div class="col-xs-12 col-md-6">
                    <kr-field
                        :display="$t('modules.teachers.create.lastnameLabel')"
                        :form="form"
                        name="lastname"
                        aria-label="last name"
                        :options="{ placeholder: 'e.g. Doe', required: true }"
                    ></kr-field>
                </div>
            </div>
            <div>
                <template v-if="mode == 'create'">
                    <kr-field
                        :display="'Email'"
                        :form="form"
                        name="email"
                        :options="{
                            placeholder: 'e.g. johndoe@example.com',
                            required: true,
                        }"
                    ></kr-field>
                </template>
                <template v-else>
                    <div class="form-group">
                        <label class="control-label">Email</label>
                        <p class="form-control-static">
                            {{ form.model.email }}
                        </p>
                    </div>
                </template>
            </div>
            <kr-toggle
                v-if="auth.user().roleId < 3 && auth.user().uuid != $route.params.id"
                name="canAddTeacher"
                :display="$t('modules.teachers.create.canAddTeacherLabel')"
                :form="form"
                class="marginBottom15 flexSpaceBetween"
                :options="{
                    setWidth: true,
                }"
            >
            </kr-toggle>
            <kr-toggle
                v-if="auth.user().roleId < 3 && auth.user().uuid != $route.params.id"
                name="canViewQuestionBank"
                :display="$t('modules.teachers.create.canViewQuestionBankLabel')"
                :form="form"
                class="marginBottom15 flexSpaceBetween"
            >
            </kr-toggle>
            <div class="col-xs-12 flex">
                <div class="col-xs-12 col-md-6">
                    <kr-field
                        :display="$t('modules.teachers.create.jobDesignationLabel')"
                        :form="form"
                        name="jobTitle"
                        :aria-label="$t('modules.teachers.create.jobDesignationAriaLabel')"
                        :options="{ placeholder: 'Enter job title' }"
                    ></kr-field>
                </div>
                <div class="col-xs-12 col-md-6 marginBottom30">
                    <kr-select
                        class="no-error"
                        :display="$t('modules.teachers.create.academicDisciplineLabel')"
                        name="academicDiscipline"
                        :form="form"
                        :items="kr_var.academicDisciplines"
                        item_value_idx="value"
                        item_desc_idx="description"
                    >
                        <template #option="props">
                            <option value="null" disabled selected>Select your option</option>
                            <template v-for="option in props.model" :key="option.value">
                                <option :value="option.value">
                                    {{ option.description }}
                                </option>
                            </template>
                        </template>
                    </kr-select>
                </div>

                <div v-if="departmentEnabled" class="col-xs-12 marginBottom30">
                    <DepartmentSelectVue3
                        ref="departmentSelectTeacherProfileRef"
                        :options="departmentOptions"
                        :dropUp="true"
                        :editClasses="{
                            addClassToButton: ['padding10px', 'width100'],
                        }"
                        :showSelection="true"
                        :level1Label="departmentMeta.settings.level >= 1 ? departmentMeta.settings.level1.plural : null"
                        :level2Label="departmentMeta.settings.level == 2 ? departmentMeta.settings.level2.plural : null"
                        @changeDepartment="
                            form.model.level1DepartmentId = $event.department?.id;
                            form.model.level2DepartmentId = $event.school?.id;
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import KrAuth from '../../../../components/auth/auth';

const props = defineProps({
    form: Object,
    mode: String,
    accounts: Array,
    isSetAccount: Boolean,
});

const auth = new KrAuth();
const account = ref({});

const departmentSelectTeacherProfileRef = ref(null);

const departmentEnabled = ref(false);
const departmentOptions = ref([]);
const departmentMeta = ref({});

const activatedDepartment = ref(null);
const activatedSchool = ref(null);

const changedAccount = () => {
    let account_uuid = props.form.model.accountUuid;
    account.value = _.find(props.accounts, function (o) {
        return o.uuid == account_uuid;
    });
};

const getDepartmentOptions = () => {
    axios.get('/departments').then(function (response) {
        departmentEnabled.value = response.data.meta.enabled;
        departmentOptions.value = response.data.data;
        departmentMeta.value = response.data.meta;

        if (departmentEnabled.value) {
            activatedDepartment.value = departmentOptions.value.find((department) => department.id === props.form.model.level1DepartmentId);
            activatedSchool.value = null;

            if (props.form.model.level2DepartmentId) {
                activatedSchool.value = departmentOptions.value
                    .find((department) => department.id === props.form.model.level1DepartmentId)
                    ?.level2Departments.find((school) => school.id === props.form.model.level2DepartmentId);
            }
        }
    });
};

watch(
    departmentSelectTeacherProfileRef,
    (newVal) => {
        if (departmentEnabled.value) {
            departmentSelectTeacherProfileRef.value?.updateActiveDepartment(activatedDepartment.value, activatedSchool.value);
        }
    },
    { immediate: true }
);

onMounted(() => {
    getDepartmentOptions();
    changedAccount();
});
</script>
